import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import api from '../../lib/api';

const sym = (c) => (c === 'inr' ? '₹' : '$');
const fmt = (d) => { try { return new Date(d).toLocaleDateString(undefined, { dateStyle: 'medium' }); } catch { return '—'; } };
const statusColor = {
  paid: 'bg-green-100 text-green-700', free: 'bg-green-50 text-green-700',
  pending: 'bg-amber-100 text-amber-700', failed: 'bg-red-100 text-red-700',
};

const PaymentHistory = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/payments/history').then((res) => setItems(res.data || [])).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6">
      <div><div className="eyebrow mb-2">Account</div><h1 className="font-serif-display text-4xl text-burgundy">Payment <span className="font-italic-display text-rose-italic">History</span></h1></div>

      {loading ? <div className="flex items-center gap-2 text-mahogany"><Loader2 className="w-4 h-4 animate-spin" /> Loading…</div>
        : items.length === 0 ? <div className="p-8 text-center text-mahogany/60 bg-white/60 rounded-2xl border border-rose/40">No transactions yet.</div>
        : (
          <div className="overflow-x-auto rounded-2xl border border-rose/40 bg-white/70">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-mahogany/70 border-b border-rose/40">
                <th className="px-4 py-3 font-medium">Date</th>
                <th className="px-4 py-3 font-medium">Description</th>
                <th className="px-4 py-3 font-medium">Type</th>
                <th className="px-4 py-3 font-medium">Amount</th>
                <th className="px-4 py-3 font-medium">Status</th>
              </tr></thead>
              <tbody>
                {items.map((t, i) => (
                  <tr key={t.id || t.session_id || i} className="border-b border-rose/20 last:border-0">
                    <td className="px-4 py-3 text-burgundy/80 whitespace-nowrap">{fmt(t.date)}</td>
                    <td className="px-4 py-3 text-burgundy">{t.description}</td>
                    <td className="px-4 py-3 capitalize text-burgundy/70">{t.kind}</td>
                    <td className="px-4 py-3 text-burgundy whitespace-nowrap">{sym(t.currency)}{Number(t.amount || 0).toFixed(2)}</td>
                    <td className="px-4 py-3"><span className={`text-[10px] uppercase tracking-widest px-2 py-1 rounded-full ${statusColor[t.status] || 'bg-mahogany/10 text-mahogany'}`}>{t.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
};

export default PaymentHistory;
